import { element } from 'protractor';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { LoadingController, NavParams, ModalController } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OrderComponent } from '../order/order.component';
import { ChatComponent } from '../chat/chat.component';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-coupon',
    templateUrl: './coupon.component.html',
    styleUrls: ['./coupon.component.scss'],
})
export class CouponComponent implements OnInit {

    coupon: any;
    orders: any = [];
    couponForm: FormGroup;
    unlimited: any = false;
    total_orders: any = 0;
    total: any = 0;
    list_supplier: any = []
    supplier: any = ''
    listTypeCoupons: any = ['free_delivery', 'supplier_discount', 'second_round']
    // listTypeCoupons: any = ['free_delivery', 'supplier_discount']
    // listTypeCoupons: any = ['free_delivery']
    type: any
    listSupplierProduct: any = []
    supplierProduct: any = ''
    discount_percentage: any = 0
    // descuento sobre el total de la compra
    second_round_discount: any = 0
    second_round__mount_min: any = 0
    

    constructor(
        public api: ApiService,
        public loadingCtrl: LoadingController,
        public navParams: NavParams,
        public modalController: ModalController,
        private http: HttpClient,
        public auth: AuthService,
        public formBuilder: FormBuilder
    ) {
        this.coupon = navParams.get('coupon');
        this.type = this.coupon.type
        this.supplier = this.coupon.supplier
        // descuento por porcentaje de proveedor
        this.discount_percentage = this.coupon.discount_percentage
        // descuento sobre el total de la compra
        this.second_round_discount = this.coupon.second_round_discount
        this.second_round__mount_min = this.coupon.minimum

        this.unlimited = this.coupon.uses.unlimited;

        this.couponForm = this.formBuilder.group({
            code: [this.coupon.code, [Validators.required]],
            available: [this.coupon.available, [Validators.required]],
            type: [this.coupon.type, [Validators.required]],
            uses: [this.coupon.uses, [Validators.required]],
            supplier: [''],
            discount_percentage: [''],
            second_round_discount: [''],
            minimum: [''],
            countryCode: this.auth.countryCode
        });

        this.api.getRef('orders').ref
            .where('coupon', '==', this.coupon.code)
            .orderBy('added_date', 'desc')
            .get()
            .then(snapshots => {
                this.total_orders = snapshots.size;
                snapshots.forEach(element => {
                    let order = element.data();
                    order.date = order.added_date.toDate();
                    order.$key = element.id;

                    if (order.status !== 'canceled') {
                        if (order.total) {
                            this.total += Number(order.total);
                        }
                    }

                    this.orders.push(order);
                });

                console.log(this.orders);


            })
    }

    ngOnInit() {
        // this.getSupplier()
    }

    changeUnlimited(e) {
        if (e.detail.checked) {
            this.unlimited = true;
            this.coupon.uses = {
                unlimited: true
            };
        } else {
            this.unlimited = false;
            this.coupon.uses = 0;
        }
    }

    updateCoupon() {
        this.loader().then(loader => {
            loader.present().then(() => {
                let data = this.couponForm.value;
                data.created_at = new Date()
                if (this.unlimited) {
                    data.uses = { unlimited: true };
                }
                data.type = this.type
                

                console.log(data)
                this.api.updateDocument('coupons', this.coupon.$key, data).then(data => {
                    loader.dismiss();
                    this.coupon = data;
                    Swal.fire(
                        'Cupon actualizado',
                        'success'
                    )
                })
            })
        })

    }

    async loader() {
        return await this.loadingCtrl.create({
            spinner: 'lines-small',
            animated: true,
            mode: 'ios',
            translucent: false,
            cssClass: 'custom-class custom-loading',
        });
    }

    async selectOrder(order) {

        const modal = await this.modalController.create({
            component: OrderComponent,
            cssClass: 'addModal',
            componentProps: {
                order: order
            }
        });
        return await modal.present();

    }

    async selectChat(chat) {
        console.log('selecionado chat');

        const modal = await this.modalController.create({
            component: ChatComponent,
            cssClass: 'addModal',
            componentProps: {
                conversation_key: chat.$key
            }
        });
        return await modal.present();

    }

    // se comenta - la operacion debe ser realizada desde monitor
    changeStatus(order, status) {
        console.log("cambio de estado se desactiva")
        // Swal.fire({
        //     title: 'Esta seguro que deseas cambiar el estado?',
        //     text: "¡No podrás revertir esto!",
        //     icon: 'warning',
        //     showCancelButton: true,
        //     confirmButtonColor: '#3085d6',
        //     cancelButtonColor: '#d33',
        //     confirmButtonText: 'Si, estoy seguro'
        // }).then((result) => {
        //     if (result.value) {
        //         this.api.updateDocument(`orders`, order.$key, { status: status }).then(data => {
        //             order.status = status;
        //             let message;
        //             if (status == 'making') {
        //                 message = `Tu orden #${order.number} se está preparando 🔥`
        //             } else if (status == 'way') {
        //                 message = `Tu orden #${order.number} ya va de camino 🚚`
        //             } else if (status == 'delivered') {
        //                 message = `Tu orden #${order.number} ha sido entregada 🏡`
        //             }

        //             this.api.getAllDocuments(`accounts/${order.account.$key}/push_keys`).then(keys => {
        //                 if (keys) {
        //                     let push_keys = [];
        //                     keys.forEach(element => {
        //                         push_keys.push(element.push_key);
        //                     });

        //                     this.api.sendPush(`Actualización de estado`, message, push_keys);
        //                 }
        //             })

        //             Swal.fire(
        //                 'Estado actualizado!',
        //                 'Tu estado ha sido actualizado correctamente',
        //                 'success'
        //             )
        //         });
        //     }

        // })
    }
    // se remueve la llamada en el FrondEnd
    capture(order) {
        this.loader().then(loader => {
            loader.present().then(() => {

                Swal.fire({
                    title: 'Esta seguro que deseas Aceptar la transferencia?',
                    text: "¡No podrás revertir esto!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, estoy seguro'
                }).then((result) => {
                    if (result.value) {
                        let getData = `orderNo=${order.number}&amount=${order.total}&type=1`;
                        let url;
                        if (this.auth.countryCode == 'SV') {
                            url = `https://payments.barlleno.app/transactionModification.php?${getData}`;
                        } else if (this.auth.countryCode == 'GT') {
                            url = `https://payments.barlleno.app/gt/transactionModification.php?${getData}`;
                        }

                        this.http.get(url).subscribe((response) => {
                            if (response['TransactionModificationResult']['ResponseCode'] == 1) {
                                this.api.updateDocument('orders', order.$key, {
                                    'transaction_status': 'captured',
                                    'status': 'making'
                                }).then(data => {
                                    order.transaction_status = 'captured';
                                    Swal.fire(
                                        'Transacción Capturada',
                                        'Captura de fondos realizar con exito',
                                        'success'
                                    )
                                })
                            } else {
                                Swal.fire(
                                    'Error!',
                                    'No se pudo completar la captura de fondos, comnunicate con el equipo de barlleno',
                                    'error'
                                )
                            }
                            loader.dismiss();
                        }, err => {
                            loader.dismiss();
                        });
                    } else {
                        loader.dismiss();
                    }
                });
            })
        })
    }
    // se remueve la llamada en el FrondEnd
    revert(order) {

        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer prv_prod_PWw13Ai1yGYJuTF6BQJ99nG8w9MkTHAw'
            })
        };

        this.loader().then(loader => {
            loader.present().then(() => {
                Swal.fire({
                    title: 'Esta seguro que deseas Revertir la transferencia?',
                    text: "¡No podrás revertir esto!",
                    icon: 'error',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, estoy seguro'
                }).then((result) => {
                    if (result.value) {
                        let getData = `orderNo=${order.number}&amount=${order.total}&type=3`;
                        let url;
                        let id_transaction = this.orders.transaction_id;
                        if (this.auth.countryCode == 'CO') {
                            url = `https://production.wompi.co/v1/transactions/?${id_transaction}/void`;
                        } else if (this.auth.countryCode == 'SV') {
                            url = `https://payments.barlleno.app/transactionModification.php?${getData}`;
                        } else if (this.auth.countryCode == 'GT') {
                            url = `https://payments.barlleno.app/gt/transactionModification.php?${getData}`;
                        }

                        this.http.get(url)
                        url
                            .subscribe((response) => {
                                if (response['TransactionModificationResult']['ResponseCode'] == 1 || response['data']['status'] == 'VOIDED') {
                                    this.api.updateDocument('orders', order.$key, {
                                        'transaction_status': 'Reverted',
                                        'status': 'canceled'

                                    }).then(data => {
                                        order.transaction_status = 'reverted';
                                        Swal.fire(
                                            'Transacción Revertida',
                                            'Reversión de fondos realizar con exito',
                                            'success'
                                        )
                                    })
                                } else {
                                    Swal.fire(
                                        'Error!',
                                        'No se pudo completar, comunicate con el equipo de Barlleno',
                                        'error'
                                    )
                                }
                                loader.dismiss();
                            }, err => {
                                loader.dismiss();
                            });
                    }
                    else {
                        loader.dismiss();
                    }
                })
            })
        })
    }

    isActive(status, order_status) {

        if (order_status == 'pending') {
            if (status == 'pending') {
                return 'true';
            }
        }

        if (order_status == 'making') {
            if (status == 'pending' || status == 'making') {
                return 'true';
            }
        }

        if (order_status == 'way') {
            if (status == 'pending' || status == 'making' || status == 'way') {
                return 'true';
            }
        }

        if (order_status == 'delivered') {
            if (status == 'pending' || status == 'making' || status == 'way' || status == 'delivered') {
                return 'true';
            }
        }
    }

    cancelOrder(order) {
        Swal.fire({
            title: `Esta seguro que deseas CANCELAR la orden ${order.number}?`,
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, estoy seguro'
        }).then((result) => {
            if (result.value) {
                console.log(order);
                this.api.cancelOrder(order).then(data => {
                    order.status = 'canceled';
                })
            }

        })
    }

    onChange(evt) {
        console.log(evt)
        console.log(this.supplier)
        // this.getSupplierProduct()
    }

    getSupplierProduct() {
        this.listSupplierProduct = []
        this.api.getRef('bricks').ref
            .where('countryCode', '==', this.auth.countryCode)
            .where("supplier", "==", this.supplier)
            .get()
            .then(snippets => {
                let element_size = snippets.size
                // console.log(element_size)
                snippets.forEach(element => {
                    let supplier = element.data().name;
                    if (supplier) {
                        // console.log(supplier)
                        this.listSupplierProduct.push(supplier)
                    }
                });
                let uniq = [...new Set(this.listSupplierProduct)]

                this.listSupplierProduct = uniq.sort()

                console.log(this.listSupplierProduct)
                // console.log(uniq.sort())

            })
    }


    getSupplier() {
        this.list_supplier = []
        this.api.getRef('bricks').ref
            .where('countryCode', '==', this.auth.countryCode)
            // .where("type", "==", "brick")
            .where("type", "in", ["club", "brick"])
            .get()
            .then(snippets => {
                let element_size = snippets.size
                // console.log(element_size)
                snippets.forEach(element => {
                    let supplier = element.data().supplier;
                    if (supplier) {
                        // console.log(supplier)
                        this.list_supplier.push(supplier)
                    }
                });
                let uniq = [...new Set(this.list_supplier)]

                this.list_supplier = uniq.sort()

                console.log(this.list_supplier)

            })

    }


}
